import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";

import { ItemListRequest, ItemListResponse } from "helpers/interfaces";
import { Redirect, useHistory, useLocation } from "react-router";

interface ITicketPrioritiesContext {
    recordCount: number
    search: ISearch
    TicketPriorities: ITicketPriorities[]
    isLoading: boolean

    updateSearch: (newSearch: ISearch) => void
    doSearch: (newSearch: ISearch) => void
    changePage: (page: number) => void
    deleteTicketPriority: (TicketPriorityId: string) => Promise<void>
}

export interface ITicketPriorities {
    id: string
    sortOrder: number
    description: string
    createdOn: string
    color: string
}

export let TicketPrioritiesContext = React.createContext<ITicketPrioritiesContext>({} as ITicketPrioritiesContext);

let { Provider } = TicketPrioritiesContext;

interface ISearch extends ItemListRequest {
    description: string

}

let TicketPrioritiesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let { enqueueSnackbar } = useSnackbar()
    let location = useLocation();
    let history = useHistory();

    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20,
        description: "",

    });
    let [recordCount, setRecordCount] = useState<number>(0);


    let [isLoading, setLoading] = useState(true);
    let [TicketPriorities, setTicketPriorities] = useState<ITicketPriorities[]>([]);


    useEffect(() => {
        if (location.state)
            processState(location.state);

    }, [location.state])


    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        let request = { ...search }

        if (state.search) {
            request = {
                ...request,
                ...state.search
            }
        }

        setSearch(request)
        searchTicketPriorities(request);
    }

    let doSearch = (newSearch: ISearch) => {
        let request = {
            ...newSearch,
            pageNr: 0
        }

        history.push(location.pathname, { search: request });
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let searchTicketPriorities = async (searchRequest: ISearch) => {
        try {
            setLoading(true);

            let response = await axios.post<ItemListResponse<ITicketPriorities>>('/api/TicketPriority/SearchTicketPriority', searchRequest);
            setTicketPriorities(response.data.items);
            setRecordCount(response.data.recordCount);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let changePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }

    let deleteTicketPriority = async (TicketPriorityId: string) => {
        if (window.confirm("Are you sure that you want to remove this TicketPriority?")) {
            try {
                let a = await axios.delete(`/api/TicketPriority/DeleteTicketPriority/${TicketPriorityId}`);
                setTicketPriorities(TicketPriorities.filter(TicketPriority => TicketPriority.id !== TicketPriorityId));
                enqueueSnackbar("TicketPriority deleted", { variant: 'success' });

            } catch (err) { }
        }
    }

    return (
        <Provider value={{
            recordCount,
            search,
            TicketPriorities,
            isLoading,

            changePage,
            doSearch,
            updateSearch,
            deleteTicketPriority
        }}>
            {children}
        </Provider>
    );
};

export default TicketPrioritiesProvider